import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "@/contexts/AuthContext";
import { LoginPage } from "@/pages/Login/LoginPage";
import { AppLayout } from "@/components/layout/AppLayout";
import { DashboardPage } from "@/pages/Dashboard/DashboardPage";
import { FleetPage } from "@/pages/Fleet/FleetPage";
import { OperativosPage } from "@/pages/Operativos/OperativosPage";
import { HitsPage } from "@/pages/Hits/HitsPage";
import { HotlistPage } from "@/pages/Hotlist/HotlistPage";
import { CatalogosPage } from "@/pages/Catalogos/CatalogosPage";
import { ReportsPage } from "@/pages/Reports/ReportsPage";
import { AuditPage } from "@/pages/Audit/AuditPage";
import { SettingsPage } from "@/pages/Settings/SettingsPage";
import { UnitDetailPage } from "@/pages/UnitDetail/UnitDetailPage";
import { OperativoDetailPage } from "@/pages/OperativoDetail/OperativoDetailPage";

export function AppRouter() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-muted">
        Cargando…
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/fleet" element={<FleetPage />} />
        <Route path="/units/:id" element={<UnitDetailPage />} />
        <Route path="/operativos" element={<OperativosPage />} />
        <Route path="/operativos/:id" element={<OperativoDetailPage />} />
        <Route path="/hits" element={<HitsPage />} />
        <Route path="/hotlist" element={<HotlistPage />} />
        <Route path="/catalogos" element={<CatalogosPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}
